import React from 'react'
import logo from './logo.png'

const Header = () => {
    return (
        <header className='center'>
            <img src={logo} alt="Breaking Bad logo"/>                        
        </header>
    )
}

export default Header
